<template>
  <div id="claim-report-list">
    <vs-row style="flex-wrap: wrap-reverse">
      <vs-col vs-lg="9" vs-sm="12">
        <div>
          <div class="pagination-area">
            <paging-navigation
              :startItemNumber="startItemNumber"
              :endItemNumber="endItemNumber"
              :totalItemNumber="totalItemNumber"
              :isPreviousActive="isPreviousPage"
              :isNextActive="isNextPage"
              :onPreviousClick="onPreviousPage"
              :onNextClick="onNextPage"
              :onSelectDisplayNumber="onSelectDisplayNumber"
            >
            </paging-navigation>
          </div>
          <div class="list-controller">
            <div></div>
            <div class="filter-area">
              <search-input
                class="filter-input"
                placeholder="整理番号/タイトル/船舶名"
                :onInputEnter="onSearchEnter"
              ></search-input>
              <hull-dropdown-select
                class="filter-input"
                :selectOptions="filterVesselOptions"
                :onSelect="onSelectFilterVessel"
                :selectedValue="selectedFilterVesselId"
                placeholder="船舶名"
                clearable
                :bordered="false"
                :isSearchable="true"
              ></hull-dropdown-select>
              <hull-dropdown-select
                class="filter-input"
                :selectOptions="filterStatusOptions"
                :onSelect="onSelectStatusFilter"
                :selectedValue="selectedFilterStatus"
                placeholder="ステータス"
                clearable
                :bordered="false"
              ></hull-dropdown-select>
              <hull-date-picker
                class="filter-calendar-input"
                :applyCallBack="onSelectAccidentDate"
                clearable
              ></hull-date-picker>
            </div>
          </div>

          <hull-list
            :data="data"
            :columns="
              this.enterpriseKind == 1
                ? columnsForVesselOwner
                : columnsForInsuranceCompany
            "
            :pagination="true"
            :displayItems="displayItems"
            :isSearchResultNoData="isSearchResultNoData"
            :noDataRegistered="noDataRegistered"
            :isHoverMenuActive="false"
            :onClickLinkString="toClaimReportView"
            :highlightCondition="highlightCondition"
            :allowCellLineBreak="false"
          >
            <template v-slot:isSearchResultNoData>
              <div class="list-message-label aisea-text-20-400-gray-black">
                検索条件に一致する事故が見つかりませんでした。
              </div>
            </template>
            <template v-slot:noDataRegistered>
              <div class="list-message-label aisea-text-20-400-gray-black">
                事故が登録されていません。
              </div>
              <common-button
                v-if="enterpriseKind == 1"
                title="事故報告"
                icon="add"
                :click="toClaimReportAdd"
              ></common-button>
            </template>
          </hull-list>
        </div>
      </vs-col>
      <vs-col class="right-widget-area" vs-lg="3" vs-sm="12">
        <template v-if="enterpriseKind == 1">
          <common-button
            title="事故報告"
            icon="add"
            :click="toClaimReportAdd"
          ></common-button>
        </template>
        <template v-else-if="enterpriseKind == 2">
          <hull-navigation-select
            class="mb-4"
            menuButtonLabel="メニュー"
            :menuItemOptions="getMenuItemOptions(this.$route.name)"
          >
          </hull-navigation-select>

          <claim-count-label
            itemLabel="対応中事故件数"
            :count="claimReportCountInProgress"
            class="my-4"
          ></claim-count-label>
          <progress-percent-chart
            :chartData="progressChartData"
            class="my-4"
          ></progress-percent-chart>
          <claim-types-chart
            :chartData="claimTypesChartData"
            class="my-4"
          ></claim-types-chart>
        </template>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import HullList from "../components/molecules/HullList";
import SearchInput from "../components/molecules/SearchInput";
import PagingNavigation from "../components/molecules/PagingNavigation";
import CommonButton from "../components/molecules/CommonButton.vue";
import ClaimCountLabel from "../components/molecules/ClaimCountLabel.vue";
import HullNavigationSelect from "../components/molecules/HullNavigationSelect.vue";
import HullDropdownSelect from "../components/molecules/HullDropdownSelect.vue";
import HullDatePicker from "../components/molecules/HullDatePicker.vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import ClaimTypesChart from "../components/molecules/ClaimTypesChart.vue";
import ProgressPercentChart from "../components/molecules/ProgressPercentChart.vue";
import { HULL_INSURANCE_ACCIDENT_TYPE } from "@/config/const";
import FireStoreService from "@/services/fireStoreService";
import moment from "moment";
const claimReportRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseClaimReport"
);
const statisticsRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseStatistics"
);

import {
  HULL_INSURANCE_INPUT_TYPE,
  HULL_INSURANCE_CLAIM_REPORT_STATUS_LABEL,
} from "@/config/const";
import { HullInsranceMixin } from "@/mixins";

export default {
  name: "T.RequiredInfoList",
  mixins: [HullInsranceMixin],
  components: {
    SearchInput,
    PagingNavigation,
    HullList,
    CommonButton,
    ClaimCountLabel,
    HullNavigationSelect,
    HullDropdownSelect,
    ClaimTypesChart,
    ProgressPercentChart,
    HullDatePicker,
  },
  data() {
    return {
      enterpriseKind: null,

      startItemNumber: 0,
      endItemNumber: 0,
      totalItemNumber: 0,
      currentPage: 0,
      pageSize: 10,

      isPreviousPage: false,
      isNextPage: false,

      displayItems: {
        number: 10,
      },
      columns: [
        {
          displayName: "ステータス",
          inputType: "status",
          key: "status",
          searchable: false,
        },
        {
          displayName: "整理番号",
          inputType: "string",
          key: "reference_no",
          searchable: true,
        },
        {
          displayName: "タイトル",
          inputType: "linkString",
          key: "title",
          searchable: true,
        },
        {
          displayName: "船舶名",
          inputType: "string",
          key: "vessel_name",
          searchable: true,
        },
        {
          displayName: "事故日",
          inputType: "string",
          key: "accident_date",
          searchable: true,
        },
        {
          displayName: "事故場所",
          inputType: "string",
          key: "accident_place",
          searchable: true,
        },
        {
          displayName: "保険契約者",
          inputType: "string",
          key: "company_name",
          searchable: false,
        },
        {
          displayName: "船主担当者",
          inputType: "string",
          key: "vessel_contact_name",
          searchable: false,
        },
        {
          displayName: "保険会社担当者",
          inputType: "string",
          key: "insurance_contact_name",
          searchable: false,
        },
      ],
      data: [
        /*
        {
          id: "4",
          claim_type_name: "PA（通常の修繕費）",
          step: "第一報/事故の状況確認/サーベイ",
          update_date: "2023/04/22",
          status: {
            label: "受付中",
            color: "EB5757",
          },
        },
        */
      ],

      searchKeyword: "",

      filterVesselOptions: [],
      filterStatusOptions: [],
      selectedFilterVesselId: null,
      selectedFilterAccidentStartAt: null,
      selectedFilterAccidentEndAt: null,
      selectedFilterStatus: null,

      inputTypeSelectOptions: HULL_INSURANCE_INPUT_TYPE,

      progressChartData: [
        /*
        {
          label: "0~25%",
          value: 50,
          color: "#ff3399",
        },

        */
      ],
      claimTypesChartData: [
        /*
        {
          label: "項目名1",
          value: 50,
          color: "#ff3399",
        },
        */
      ],
      claimReportCountInProgress: 0,
    };
  },
  async created() {
    this.enterpriseKind = await this.getEnterpriseKind();
    await this.initializeDisplayNumber();
    if (this.enterpriseKind == 2) {
      await this.fetchStatisticData();
    }
    await this.fetchFilterOptions();
    this.callFetch();
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
  },
  computed: {
    columnsForInsuranceCompany() {
      return this.columns;
    },
    columnsForVesselOwner() {
      return this.columns.filter(element => element.key != "company_name");
    },
    isSearchResultNoData() {
      return (
        (this.searchKeyword != "" ||
          this.selectedFilterVesselId != null ||
          this.selectedFilterAccidentStartAt != null ||
          this.selectedFilterAccidentEndAt != null ||
          this.selectedFilterStatus) &&
        this.data.length == 0 &&
        this.currentPage == 0
      );
    },
    noDataRegistered() {
      return (
        !this.isSearchResultNoData &&
        this.data.length == 0 &&
        this.currentPage == 0
      );
    },
  },
  methods: {
    async initializeDisplayNumber() {
      const res = await FireStoreService.getAccountSetting("claim_report_list");
      if (res && res.page_size) {
        this.pageSize = res.page_size;
      } else {
        this.pageSize = 10;
      }
    },
    saveDisplayNumberInFireStore() {
      FireStoreService.setAccountSetting("claim_report_list", {
        page_size: this.pageSize,
      });
    },
    async fetchStatisticData() {
      const res = await statisticsRepository.fetch();
      if (res.status == true) {
        const data = res.data.progress_rate;
        let arr = [];
        arr.push({
          label: `0~25% : ${data.num0_to25}件`,
          value: data.num0_to25,
          color: "#EB5757",
        });
        arr.push({
          label: `26%~50% : ${data.num26_to50}件`,
          value: data.num26_to50,
          color: "#26A69A",
        });
        arr.push({
          label: `51%~75% : ${data.num51_to75}件`,
          value: data.num51_to75,
          color: "#857AF2",
        });

        arr.push({
          label: `76%~ : ${data.num76_to100}件`,
          value: data.num76_to100,
          color: "#FF9800",
        });
        this.progressChartData = arr;

        const nums = res.data.claim_kind_nums;
        this.claimTypesChartData = nums.map(element => {
          const type = this.getAccidentTypeByValue(element.key);
          return {
            label: `${type.label} : ${element.value}件`,
            value: element.value,
            color: type.color,
          };
        });

        this.claimReportCountInProgress = res.data.num_in_progress;
      } else {
        this.$vs.notify({
          title: "統計データの取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    getAccidentTypeByValue(value) {
      const obj = HULL_INSURANCE_ACCIDENT_TYPE;
      const keys = Object.keys(obj);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (obj[key].value === value) {
          return obj[key];
        }
      }
      return null;
    },
    getClaimReportStatusByValue(value) {
      const obj = HULL_INSURANCE_CLAIM_REPORT_STATUS_LABEL;
      const keys = Object.keys(obj);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (obj[key].value === value) {
          return obj[key];
        }
      }
      return null;
    },
    async fetchFilterOptions() {
      const res = await claimReportRepository.fetchVessels();
      if (res.status == true) {
        this.filterVesselOptions = res.data.vessel.map(element => {
          return {
            text: element.name,
            value: element.vessel_id,
          };
        });
        this.filterStatusOptions = Object.values(
          HULL_INSURANCE_CLAIM_REPORT_STATUS_LABEL
        ).map(element => {
          return {
            text: element.label,
            value: element.value,
          };
        });
      } else {
        this.$vs.notify({
          title: "船舶名の取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    onSelectFilterVessel(value) {
      this.selectedFilterVesselId = value;
      this.currentPage = 0;
      this.callFetch();
    },
    onSelectStatusFilter(value) {
      this.selectedFilterStatus = value;
      this.currentPage = 0;
      this.callFetch();
    },
    onSelectAccidentDate(value) {
      if (value == null) {
        this.selectedFilterAccidentStartAt = null;
        this.selectedFilterAccidentEndAt = null;
        this.currentPage = 0;
        this.callFetch();
      } else if (value.length == 2) {
        this.selectedFilterAccidentStartAt = value[0];
        this.selectedFilterAccidentEndAt = value[1];
        this.currentPage = 0;
        this.callFetch();
      }
    },

    onSelectDisplayNumber(number) {
      this.pageSize = number;
      this.currentPage = 0;
      this.saveDisplayNumberInFireStore();
      this.callFetch();
    },
    onSearchEnter(searchKeyword) {
      this.searchKeyword = searchKeyword;
      this.currentPage = 0;
      this.callFetch();
    },
    clickAddClaimTypeButton() {
      this.$refs.AddModal.show();
    },
    async callFetch() {
      this.$vs.loading();
      const res = await claimReportRepository.fetch({
        search_word: this.searchKeyword,
        page: this.currentPage,
        size: this.pageSize,
        status: this.selectedFilterStatus,
        vessel_id: this.selectedFilterVesselId,
        start_at: this.selectedFilterAccidentStartAt
          ? moment(this.selectedFilterAccidentStartAt).format("YYYY-MM-DD")
          : null,
        end_at: this.selectedFilterAccidentEndAt
          ? moment(this.selectedFilterAccidentEndAt).format("YYYY-MM-DD")
          : null,
        //accident_date: this.selectedFilterAccidentDate,
      });
      this.$vs.loading.close();
      if (res.status == true) {
        this.data = res.data.claim_reports.map(element => {
          const reportStaffs = element.report_staffs;
          const vesselOwnerStaffNames = reportStaffs
            .filter(element => element.enterprise_kind == 1)
            .map(element => element.contact_info.name);
          const insuranceCompanyStaffNames = reportStaffs
            .filter(element => element.enterprise_kind == 2)
            .map(element => element.contact_info.name);
          const companyName = reportStaffs[0].company_name;
          const vesselContactName =
            vesselOwnerStaffNames.length > 0 ? vesselOwnerStaffNames[0] : "";
          const insuranceContactName =
            insuranceCompanyStaffNames.length > 0
              ? insuranceCompanyStaffNames[0]
              : "";
          return {
            id: element.id,
            reference_no: element.reference_no,
            title: element.title,
            vessel_name: element.vessel_name,
            accident_date: element.accident_date
              ? element.accident_date.replace(/-/g, "/")
              : null,
            accident_place: element.accident_place,
            company_name: companyName,
            vessel_contact_name: vesselContactName,
            insurance_contact_name: insuranceContactName,
            status: this.getClaimReportStatusByValue(element.status),
          };
        });

        this.setPagigation(
          this.currentPage,
          res.data.total_pages,
          this.pageSize,
          res.data.claim_reports.length,
          res.data.total_elements
        );
      } else {
        this.$vs.notify({
          title: "事故一覧の取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    setPagigation(
      currentPage,
      totalPage,
      pageSize,
      displayItemNumber,
      totalItemNumber
    ) {
      this.startItemNumber = totalPage == 0 ? 0 : pageSize * currentPage + 1;
      this.endItemNumber =
        totalPage == 0 ? 0 : this.startItemNumber + displayItemNumber - 1;
      this.totalItemNumber = totalItemNumber;
      this.isNextPage = currentPage < totalPage - 1;
      this.isPreviousPage = currentPage > 0;

      this.currentPage = currentPage;
    },
    onPreviousPage() {
      this.currentPage--;
      this.callFetch();
    },
    onNextPage() {
      this.currentPage++;
      this.callFetch();
    },
    toClaimReportAdd() {
      this.$router.push({
        name: "hull-insurance-claim-report-add",
      });
    },
    toClaimReportView(id) {
      this.$router.push({
        name: "hull-insurance-claim-report-view",
        params: { id: id },
      });
    },
    highlightCondition(rowData) {
      return this.enterpriseKind == 2 && rowData.status.label == "受付中";
    },
  },
};
</script>

<style lang="scss" scoped>
#claim-report-list {
  .pagination-area {
    margin-left: auto;
    width: 150px;
    margin-bottom: 20px;
  }
  .list-controller {
    display: flex;
    margin-bottom: 20px;
    .filter-area {
      flex-grow: 1;
      display: flex;
      flex-wrap: wrap;
      .filter-input {
        width: 200px;
        margin-right: 8px;
        margin-bottom: 8px;
      }
      .filter-calendar-input {
        margin-right: 8px;
        margin-bottom: 8px;
      }
    }
  }
  .right-widget-area {
    padding-left: 20px;
    max-width: 300px;
  }
  .list-message-label {
    margin: 10px;
  }
}
</style>
